export default {
  "01M": "Chemicals",
  "01R": "Agriculture",
  "02M": "Electronics",
  "02R": "Energy resources",
  "03M": "Food & beverages",
  "03R": "Minerals",
  "04M": "Machinery",
  "05M": "Medical & scientific instruments",
  "06M": "Metal products",
  "07M": "Non-metallic mineral products",
  "08M": "Others",
  "09M": "Pharmaceutical products",
  "0AG": "All goods",
  "0MG": "Manufactured goods",
  "0RS": "Resources",
  "10M": "Rubber & plastic products",
  "11M": "Textiles",
  "12M": "Transport equipment",
  "13M": "Wood & paper products",
} as const;
